import React from 'react';
import { Button, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import DashboardUserTypeIcon from '@components/DashboardUserTypeIcon';
import PublishedStatusIcon from '@components/PublishedStatusIcon';
import { ProfilePictureAvatar } from '@components/ProfilePicture';
import { HOSPITAL_ADMIN, HOSPITAL_USER } from '@constants';

export default t => [
  {
    title: t('directChildOrganisationAdministration:users.list.fullName'),
    key: 'fullName',
    render: user => {
      const fullName = `${user.firstName} ${user.lastName}`.trim();
      return (
        <>
          <span className="direct-child-organisation-user-list-name-cell">
            <ProfilePictureAvatar url={user.profilePictureUrl} displayName={fullName} size={32} />
            <span data-testid="direct-child-organisation-user-name">{fullName}</span>
          </span>
          <span className="sr-only">
            {t(
              `directChildOrganisationAdministration:users.activation.${
                user.activated ? 'activated' : 'notActivated'
              }`,
            )}
          </span>
        </>
      );
    },
    sorter: (a, b) =>
      `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`),
    width: 250,
  },
  {
    title: t('directChildOrganisationAdministration:users.list.role'),
    key: 'role',
    render: user => (
      <>
        <DashboardUserTypeIcon
          label={false}
          userType={user.role === 'admin' ? HOSPITAL_ADMIN : HOSPITAL_USER}
        />{' '}
        {t(`directChildOrganisationAdministration:users.roles.${user.role}`)}
      </>
    ),
    sorter: (a, b) => a.role.localeCompare(b.role),
    width: 220,
  },
  {
    title: t('directChildOrganisationAdministration:users.list.organisation'),
    dataIndex: 'organisationName',
    key: 'organisation',
    sorter: (a, b) => a.organisationName.localeCompare(b.organisationName),
    width: 300,
  },
  {
    title: t('directChildOrganisationAdministration:users.list.contact'),
    key: 'contact',
    render: user => {
      const emailLabel = t('directChildOrganisationAdministration:users.list.emailUser', {
        email: user.email,
      });
      return (
        <Tooltip placement="bottom" title={emailLabel}>
          <Button
            aria-label={emailLabel}
            className="contact-button"
            href={`mailto:${user.email}`}
            type="link"
            onClick={event => event.stopPropagation()}
          >
            <FontAwesomeIcon icon={faEnvelope} size="lg" />
          </Button>
        </Tooltip>
      );
    },
    width: 150,
  },
  {
    title: t('directChildOrganisationAdministration:users.list.activated'),
    key: 'activated',
    render: user => {
      const activationLabel = t(
        `directChildOrganisationAdministration:users.activation.${
          user.activated ? 'activated' : 'notActivated'
        }`,
      );
      return (
        <Tooltip placement="bottom" title={activationLabel}>
          <span>
            <PublishedStatusIcon published={user.activated} />
          </span>
        </Tooltip>
      );
    },
    sorter: (a, b) => Number(b.activated) - Number(a.activated),
    width: 160,
  },
];
